import {
    CommentOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined,
    MailOutlined,
    PhoneOutlined,
    QuestionCircleTwoTone,
    ShoppingOutlined,
    UserOutlined,
} from '@ant-design/icons';
import {
    Badge, Button, Checkbox, Col, Divider, Drawer,
    Form, Image, Input, List, Row, Steps, message,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StoreActions from 'bukku/redux/Store/actions';
import PublicListActions from 'bukku/redux/PublicList/actions';
import FormatNumber from 'bukku/components/Store/FormatNumber';
import QuantityInputCheckout from '../QuantityInputCheckout';
import ProductInstructionFormItem from '../ProductInstructionFormItem';
import { storeCommonStyles } from 'bukku/containers/Store/commonStyles';
import { plural, Trans } from "@lingui/macro";
import PriceLevelPopover from '../Popover/PriceLevelPopover';
import Address from './Address';
import { ConditionalTooltip } from '../../Tooltip/ConditionalTooltip';
import BukkuTooltip from '../../Tooltip';

const { TextArea } = Input;

const StyledDrawer = styled(props => <Drawer rootClassName={props.className} {...props} />)`

  ${storeCommonStyles}

  .ant-drawer-body {
    padding: 18px !important;
  }

  .list-item__checkout-product {
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .row__product-container {
    width: 100%;
    min-height: 8rem;
  }

  .ant-image {
    position: relative;
    width: 100%;
    padding-top: 100%;  /* aspect ratio 1:1 */

    /* aspect ratio 1:1 */
    .image {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .image__placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 1em;
      overflow: hidden;
      font-size: 12px;
      font-weight: 400;
      color: var(--brand-color-teal);
      text-align: center;
      background-color: var(--primary-1);
    }
  }

  .img-checkout__product {
    object-fit: contain;
  }

  .btn__delete {
    &:hover,&:focus,&:active {
      border-color: #f5222d !important;

      .anticon {
        color: #f5222d !important;
      }
    }
  }

  /* Contact Details Page */
  .ant-form-item {
    .ant-form-item-label {
      padding: 0 0 4px !important;
    }

    &.ant-form-item-has-error {
        .ant-checkbox-inner { 
            border-color: #ff4d4f;
        }
    }

    &.horizontal-form--checkbox {
        flex-direction: row-reverse;

        .ant-form-item-label {
            flex: 1 0 200px;
        }

        .ant-form-item-control {
            flex: 0 0 25px;

            /* eg: 'Please agree the terms and conditions.' */
            .ant-form-item-explain { 
                position: absolute;
                top: 45px;
                width: 265px;
            }
        }
    }
  }

  .col__totals {
    display: flex;
    justify-content: space-between;
    padding: 1em;
    background: var(--neutralLightest);
    border-radius: 1em;
    box-shadow: 1px 1px 0 var(--neutral);
  }

  .ant-drawer-footer {
    padding: 10.5px 16px !important;

    .footer__col-total {
      line-height: 1.2rem;

      .footer__col-total--amount {
        color: var(--primary);
      }
    }

    .footer__col-btn {
      .ant-btn {
        height: 100%;
      }
    }
  }

  .div__empty-cart {
    display: flex;
    flex-direction: column;

    /* to center the children */
    height: 100%;

    .ant-row {
      margin: auto !important;         /* to vertically center the children */
    }

    .icon--empty-cart {
      font-size: xxx-large;
      color: var(--neutralDarker);
    }
  }

  .flex-center {
    display: flex;
    align-self: center;
    justify-content: center;
  }

`;
const {
    addItemToCart,
    removeItemFromCart,
    setItemInstruction,
    setCustomerOrderInfo,
    toggleCheckoutDrawer,
    toggleCheckoutConfirmationModal,
    recalculate,
} = StoreActions;

const {
    readPublicCountriesList,
} = PublicListActions;
class CheckoutDrawer extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            currentStep: 0,
        };
    }

    componentDidUpdate(prevProps) {
        const {
            visible,
        } = this.props;

        // Visible now.
        if (visible && !prevProps.visible)
            this.onPageLoad();

        if (!visible && prevProps.visible)
            this.onPageUnload();
    }

    onPageLoad = () => {
        const { customerOrder, recalculate, readPublicCountriesList } = this.props;
        readPublicCountriesList();
        this.formRef.current.setFieldsValue(customerOrder);
        recalculate();
    };

    onPageUnload = () => {
        this.setState({
            currentStep: 0,
        });
    };

    onDrawerClose = () => {
        const { toggleCheckoutDrawer } = this.props; // redux
        toggleCheckoutDrawer(false);
    };

    onClickDeleteFromCart = product => {
        const {
            removeItemFromCart,
        } = this.props;
        removeItemFromCart(product.productId);
    };

    renderCheckoutListItem = cartItem => {
        const {
            productData,
            store,
        } = this.props;

        const productDetail = productData.find(pd => pd.id === cartItem.productId);
        if (productDetail) {
            return (
                <List.Item className="list-item__checkout-product">
                    <Row className="row__product-container" gutter={[9, 6]}>
                        <Col span={8}>
                            <Image
                                className="image"
                                preview={!!productDetail.thumbnailUrl}
                                placeholder={<div className="image__placeholder">{productDetail.name}</div>}
                                src={productDetail.thumbnailUrl}
                            />
                        </Col>
                        <Col span={16} style={{ paddingRight: 0 }}>
                            <Row gutter={[0, 6]}>
                                <Col span={20}>
                                    <strong>{productDetail.name}</strong>
                                    <div style={{ opacity: '70%' }}>
                                        <FormatNumber
                                            currency={store.currencySymbol}
                                            amount={cartItem.unitPrice}
                                            suffix={`/ ${productDetail.unitLabel}`}
                                        />
                                    &nbsp;
                                        <PriceLevelPopover
                                            priceLevels={productDetail.unitPrice}
                                            uomLabel={productDetail.unitLabel}
                                            currentPriceLevel={cartItem.priceLevel}
                                            popupContainerId="store-checkout-drawer-list"
                                        />
                                    </div>
                                </Col>
                                <Col
                                    span={4}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignSelf: 'flex-start',
                                    }}
                                >
                                    <Button
                                        className="btn__delete"
                                        size="small"
                                        shape="circle"
                                        onClick={() => this.onClickDeleteFromCart(cartItem)}
                                        icon={<DeleteOutlined
                                            style={{ color: '#8c8c8c', fontSize: '0.9em' }}
                                        />}
                                    />
                                </Col>
                                <Col span={24} />
                                <Col span={24} style={{ alignSelf: 'flex-end' }}>
                                    <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                            <QuantityInputCheckout
                                                formRef={this.formRef}
                                                product={cartItem}
                                                width="13ch"
                                                size="small"
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <ProductInstructionFormItem
                                                formRef={this.formRef}
                                                product={cartItem}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </List.Item>
            );
        }
        return null;
    };

    nextStep = () => {
        const {
            currentStep,
        } = this.state;

        this.setState({
            currentStep: currentStep + 1,
        });
    };

    onChangeStep = step => {
        this.setState({
            currentStep: step,
        });
    };

    // renderSkeleton = () => {
    //     return <>
    //         <Skeleton.Input style={{ width: 120, marginBottom: '1rem' }} active />
    //         <br />
    //         <Skeleton.Image />
    //         <Divider />
    //         <Skeleton active />
    //     </>
    // }

    renderCartReview = () => {
        const {
            shoppingCart,
            store,
            totals,
        } = this.props;

        return (
            <>
                {/* <p>Shopping Cart {JSON.stringify(shoppingCart)}</p>
                <p>productData List {JSON.stringify(productData)}</p> */}
                <List
                    itemLayout="horizontal"
                    dataSource={shoppingCart}
                    renderItem={cartItem => this.renderCheckoutListItem(cartItem)}
                    id="store-checkout-drawer-list"
                />
                <Row>
                    <Col className="col__totals" span={24}>
                        <h3 style={{ alignSelf: 'center' }}>Total</h3>
                        <FormatNumber
                            currency={store.currencySymbol}
                            amount={totals.grandTotal}
                            fontSizeLevel="large"
                        />
                    </Col>
                </Row>
            </>
        );
    };

    renderOrderDetailForm = () => {
        const {
            emailsRegExp,
        } = this.props;

        return (
            <>
                <Form.Item
                    name="customerName"
                    label={(
                        <>
                            <UserOutlined />
                            &nbsp;Name
                        </>
                    )}
                    rules={[{ required: true, message: 'Please enter your name.' }]}
                >
                    <Input placeholder="John Doe" />
                </Form.Item>
                <Form.Item
                    name="customerMobile"
                    label={(
                        <>
                            <PhoneOutlined />
&nbsp;Mobile No.
                        </>
                    )}
                    rules={[{ required: true, message: 'Please enter your mobile number.' }]}
                >
                    <Input placeholder="012-3456789" />
                </Form.Item>
                <Form.Item
                    name="customerEmail"
                    label={(
                        <>
                            <MailOutlined />
&nbsp;Email&nbsp;
                            <BukkuTooltip
                                title="Enter your email to receive invoice for this order."
                                // popupType="drawer"
                            >
                                <QuestionCircleTwoTone />

                            </BukkuTooltip>
                        </>
                    )}
                    rules={[
                        { required: true, message: 'Please enter your email.' },
                        { pattern: new RegExp(emailsRegExp), message: 'Email address is invalid.' },
                    ]}
                >
                    <Input placeholder="john@mail.com" />
                </Form.Item>
                <Form.Item
                    name="instruction"
                    label={(
                        <>
                            <CommentOutlined />
&nbsp;Order Instructions / Alternative Contact
                        </>)}
                    rules={[]}
                >
                    <TextArea placeholder="e.g. No plastic bags" />
                </Form.Item>
                <Divider />
                <Address />
                <Divider />
                <Form.Item
                    name="agreePrivacyPolicy"
                    className="horizontal-form--checkbox"
                    valuePropName="checked"
                    label={(
                        <span>
                            I have read and agree to the&nbsp;
                            <a
                                href="https://bukku.my/privacy-policy/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy

                            </a>
                        </span>
                    )}
                    rules={[{
                        required: true,
                        transform: value => (value || undefined), // Those two lines
                        type: 'boolean', // Do the magic to determine false
                        message: 'Please agree to the privacy policy.',
                    }]}
                >
                    <Checkbox />
                </Form.Item>
                <br />
            </>
        );
    };

    renderContent = () => {
        const {
            currentStep,
        } = this.state;

        switch (currentStep) {
            case 0:
                return this.renderCartReview();
            case 1:
                return this.renderOrderDetailForm();
            default:
                break;
        }
        return null;
    };

    renderDrawerFooter = () => {
        const {
            currentStep,
        } = this.state;

        const {
            store,
            totals,
            shoppingCart,
        } = this.props;

        const {
            hasPaymentGateway,
            paymentGatewayProvider,
            minimumSpend,
        } = store;
        const isCheckoutDisabled = hasPaymentGateway && paymentGatewayProvider === 'stripe' &&
                                    totals.grandTotal < minimumSpend;
        const minimumSpendTooltipTitle = (
            <Trans>
                Minimum spend of&nbsp;
                <FormatNumber
                    amount={minimumSpend}
                    currency={store.currencySymbol}
                />
                required.
            </Trans>
        );

        console.log('aaa store', {store, totals});
        return (
            <Row align="middle" gutter={16}>
                <Col flex="none" className="footer__col-total">
                    <Badge
                        size="small"
                        offset={[2, 0]}
                        count={shoppingCart.reduce((acc, item) => acc + item.qty, 0)}
                    >
                        <ShoppingOutlined style={{ fontSize: 'large' }} />
                    </Badge>
                </Col>
                <Col flex="none" className="footer__col-total">
                    <div className="footer__col-total--amount">
                        <FormatNumber currency={store.currencySymbol} amount={totals.grandTotal} />
                    </div>
                </Col>
                <Col flex="auto" className="footer__col-btn">
                    {
                        currentStep === 0 ?
                            <ConditionalTooltip
                                rules={[
                                    {
                                        condition: isCheckoutDisabled,
                                        message: minimumSpendTooltipTitle,
                                    },
                                ]}
                            >
                                <Button
                                    type="primary"
                                    block
                                    onClick={this.nextStep}
                                >
                                    Next
                                    {
                                        isCheckoutDisabled ?
                                            <ExclamationCircleOutlined color="red" /> : null
                                    }
                                </Button>
                            </ConditionalTooltip>

                            :

                            <ConditionalTooltip
                                rules={[
                                    {
                                        condition: isCheckoutDisabled,
                                        message: minimumSpendTooltipTitle,
                                    },
                                ]}
                            >
                                <Button
                                    type="primary"
                                    block
                                    onClick={this.onSubmitCheckout}
                                >
                                    Checkout
                                    {
                                        isCheckoutDisabled ?
                                            <ExclamationCircleOutlined color="red" /> : null
                                    }
                                </Button>
                            </ConditionalTooltip>
                    }
                </Col>
            </Row>
        );
    };

    doSubmit = () => {
        const { setCustomerOrderInfo, toggleCheckoutConfirmationModal, recalculate } = this.props;
        const rawFormData = this.formRef.current.getFieldsValue();
        recalculate(); // check for price changes
        setCustomerOrderInfo(rawFormData);
        toggleCheckoutConfirmationModal(true);
    };

    onSubmitCheckout = () => {
        this.formRef.current.validateFields()
            .then(() => this.doSubmit())
            .catch(errorInfo => {
                message.warning("Please check the fields highlighted in red.");

                // console.log('aaa errorInfo', errorInfo)
                this.formRef.current.scrollToField(
                    errorInfo.errorFields[0].name,
                    {
                        behavior: actions => actions.forEach(({ el, top, left }) => {
                            if (el.className === 'ant-drawer-body') {
                                // console.log('aaa scroll', {el ,top, left})
                                // implement the scroll
                                // eslint-disable-next-line no-param-reassign
                                el.scrollTop = errorInfo.errorFields[0].name[0] === 'agreePrivacyPolicy' ?
                                    top + 50 :
                                    top;
                                // eslint-disable-next-line no-param-reassign
                                el.scrollLeft = left;
                            }
                        }),
                        inline: 'end',
                    });
            });
    };

    renderEmptyCart = () => (
        <div className="div__empty-cart">
            <Row gutter={[12, 12]}>
                <Col span={24} className="flex-center">
                    <ShoppingOutlined className="icon--empty-cart" />
                </Col>
                <Col span={24} className="flex-center">
                    <h2>Your cart is currently empty.</h2>
                </Col>
                <Col span={24} className="flex-center">
                    <Button type="primary" onClick={this.onDrawerClose}>Continue Browsing</Button>
                </Col>
            </Row>
        </div>
    );

    render() {
        const {
            currentStep,
        } = this.state;

        const {
            visible,
            shoppingCart,

        } = this.props;

        const isShoppingCartEmpty = !shoppingCart.reduce((acc, item) => acc + item.qty, 0);
        return (

            <StyledDrawer
                title={
                    plural(shoppingCart.reduce((acc, item) => acc + item.qty, 0), {
                        one: 'Your Cart: 1 item',
                        other: 'Your Cart: # items',
                    })
                }
                onClose={this.onDrawerClose}
                open={visible}
                placement="right"
                destroyOnClose
                width={320}
                footer={isShoppingCartEmpty ? false : this.renderDrawerFooter()}
            >
                {
                    isShoppingCartEmpty ?
                        this.renderEmptyCart() :
                        <>
                            <Steps
                                size="small"
                                current={currentStep}
                                responsive={false}
                                onChange={this.onChangeStep}
                                style={{ marginBottom: '1rem' }}
                                items={[{title: "Cart"}, {title: "Order Details"}]}
                            />
                            <Form ref={this.formRef} layout="vertical">
                                {this.renderContent()}
                            </Form>
                        </>
                }

            </StyledDrawer>
        );
    }
}

export default connect(state => ({
    view: state.Store.view,
    width: state.Store.width,
    store: state.Store.store,
    shoppingCart: state.Store.shoppingCart,
    customerOrder: state.Store.customerOrder,
    products: state.Store.products,
    productData: state.Store.productData,
    totals: state.Store.totals,
    visible: state.Store.checkoutDrawerVisible,
    placeOrderState: state.Store.placeOrderState,
    emailsRegExp: state.Store.emailsRegExp,
}), {
    readPublicCountriesList,
    addItemToCart,
    removeItemFromCart,
    setItemInstruction,
    setCustomerOrderInfo,
    toggleCheckoutDrawer,
    toggleCheckoutConfirmationModal,
    recalculate,
})(CheckoutDrawer);
